import axios from 'axios'
import {UposlenikModel} from '../models/UposlenikModel'
import {getAuth} from '../modules/auth'
import {RolneUDolaskuModel} from '../models/RolneUDolasku'

const API_URL = process.env.REACT_APP_API_URL
const API = `${API_URL}/rolneUDolasku`
const IMPORT_API = `${API_URL}/rolneUDolaskuImport`
const auth: UposlenikModel = getAuth()!
const headers = {Accept: 'application/json', Authorization: auth?.access_token ?? ''}

export async function getAllRolneUDolasku(params) {
    return await axios.get<Array<RolneUDolaskuModel>>(API, {headers: headers, params: params})
}

export async function saveRolneUDolasku(Data: any) {
    try {
        const response = await axios.post(API, Data, {headers: headers})
        return response.data
    } catch (error: any) {
        console.error('Error fetching data:', error)
        return error.response.data // Re-throw the error so it can be handled by the caller if necessary
    }
}

export async function fetchRolneUDolasku(Id: number): Promise<Partial<RolneUDolaskuModel>> {
    try {
        const response = await axios.get(`${API}/${Id}`)
        if (response.data && response.data.error === 0) {
            return response.data.data
        } else {
            // Handle any other type of response structure or errors returned from the server here
            throw new Error(response.data.message || 'Failed to fetch.')
        }
    } catch (error) {
        console.error('Error fetching data:', error)
        throw error // Re-throw the error so it can be handled by the caller if necessary
    }
}

export async function updateRolneUDolasku(Data: any, id: number) {
    try {
        const response = await axios.post(`${API}/${id}?_method=PATCH`, Data, {headers: headers})
        return response.data
    } catch (error: any) {
        console.error('Error fetching data:', error)
        return error.response.data // Re-throw the error so it can be handled by the caller if necessary
    }
}

export async function deleteRolneUDolasku(Id: number) {
    try {
        const response = await axios.delete(`${API}/${Id}`, {headers: headers})
        if (response.data) {
            return response
        } else {
            // Handle any other type of response structure or errors returned from the server here
            throw new Error(response.data.message || 'Failed to delete.')
        }
    } catch (error) {
        console.error('Error deleting data:', error)
        throw error // Re-throw the error so it can be handled by the caller if necessary
    }
}

export async function importRolneUDolasku(Data: any) {
    try {
        const response = await axios.post(IMPORT_API, Data, {headers: headers})
        return response.data
    } catch (error: any) {
        console.error('Error fetching data:', error)
        return error.response.data // Re-throw the error so it can be handled by the caller if necessary
    }
}

export async function prebaciRolneNaStanje(Data: any) {
    try {
        const response = await axios.post(`${API_URL}/prebaciRolneNaStanje`, Data, {headers: headers})
        if (response.data.error === 0) return response.data
        else {
            throw new Error(response.data.message)
        }
    } catch (error: any) {
        console.error('Error fetching data:', error)
        return new Error(error.response.data.message) // Re-throw the error so it can be handled by the caller if necessary
    }
}
